import { render, staticRenderFns } from "./TagFilterModal.vue?vue&type=template&id=4d538c76&scoped=true&"
import script from "./TagFilterModal.vue?vue&type=script&lang=js&"
export * from "./TagFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d538c76",
  null
  
)

export default component.exports